import {
  Component, ChangeDetectionStrategy, Input,
} from '@angular/core'
import { VariableHeadingComponent } from '@knorr-bremse-portals/ngx-components/components/variable-heading'

@Component({
  selector: 'kb-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [VariableHeadingComponent],
})
export class ContactComponent {
  @Input({ required: true }) public name!: string
  @Input() public subline?: string
  @Input() public type: 'bar' | 'floating' = 'bar'
}
